import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const CAMINHO_LOGIN = "/login";

// Telas do ERP: sem sessao, vai para o login lembrando de onde veio.
export function RotaProtegida() {
  const { autenticado, motivo } = useAuth();
  const { pathname, search, hash } = useLocation();

  if (!autenticado) {
    return (
      <Navigate
        to={CAMINHO_LOGIN}
        replace
        state={{ from: { pathname, search, hash }, motivo }}
      />
    );
  }

  return <Outlet />;
}

// Login: quem ja tem sessao vai para a tela que pediu ou para o inicio.
// E isso que leva o usuario adiante logo depois de entrar.
export function RotaPublica() {
  const { autenticado } = useAuth();
  const { state } = useLocation();

  if (autenticado) {
    return <Navigate to={state?.from?.pathname ? state.from : "/"} replace />;
  }

  return <Outlet />;
}
